import { encryptText, pbdkf2 } from "./OstreonEncryption";
import SHA from "sha.js";
import config from "../config";
import { submitCaptcha } from "./captcha";
import { buildPrivateKey } from "./beneficiaryUtils";
const base_url = config.base_url;
export const createBeneficiaryPassword = (email, birth_date, personal_code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const key_elements = `${email.toLowerCase()}:${birth_date}:${personal_code.toLowerCase()}`;
      const password = await pbdkf2(key_elements, "OSTREON", 100000, 32 * 8);
      resolve(password[0]);
    } catch (error) {
      reject(error);
    }
  });
};
export const createAccess = (body, type) => {
  return new Promise((resolve, reject) => {
    if (!body) {
      return reject("Field is missing for creating beneficiary access");
    }
    fetch(base_url + "user/beneficiaries/" + type, {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/json",
        credentials: "include",
      }, // TODO: un-comment this field for adding multipe benef. emails
      body: JSON.stringify(body),
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) resolve();
        else
          throw new Error(
            "Error: " + res.status + "while modifying beneficiary access"
          );
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};
export const sendEmail = (
  beneficiary,
  user_type = "beneficiary",
  beneficiary_emails = []
) => {
  return new Promise((resolve, reject) => {
    submitCaptcha()
      .then((token) => {
        // TODO: un-comment this field for adding multipe benef. emails
        let body = `beneficiary_name=${beneficiary.name}&user_type=${user_type}&token=${token}`;
        beneficiary_emails.map(email=>{
          body = body + `&beneficiary_email=${email}`;
        })
        if (!beneficiary.email || !beneficiary.name || !user_type)
          return reject(`Error while notifying ${user_type}`);
        fetch(base_url + "user/beneficiary/welcome", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          // body: `beneficiary_email=${beneficiary.email}&beneficiary_name=${beneficiary.name}&customer_name=${customer_name}&customer_last_name=${customer_last_name}&user_type=${user_type}&token=${token}`,
          body: body,
          credentials: "include",
        })
          .then((res) => {
            if (res.status === 200) resolve();
            else throw new Error(`Server couldnt notify ${user_type}`);
          })
          .catch((e) => {
            console.log(e);
            return reject(`Error while notifying ${user_type}`);
          });
      })
      .catch((e) => {
        console.log(e);
        return reject(`Error while notifying ${user_type}`);
      });
  });
};
export const updateBeneficiaryAccess = (private_key, beneficiary) => {
  return new Promise((resolve, reject) => {
    Promise.all([
      buildPrivateKey(private_key, beneficiary?.email, beneficiary?.birth_date, beneficiary?.personal_code),
      beneficiary?.email_2?buildPrivateKey(private_key, beneficiary?.email_2, beneficiary?.birth_date, beneficiary?.personal_code):undefined,
      beneficiary?.email_3?buildPrivateKey(private_key, beneficiary?.email_3, beneficiary?.birth_date, beneficiary?.personal_code):undefined
    ])
    .then(async (beneficiary_accesses) => {
      const body = {
        email:beneficiary.email,
        beneficiary_user_id:beneficiary.user_id,
        accesses:beneficiary_accesses
      }
      return createAccess(body,"edit");
    })
    .then(() => {
      return resolve();
    })
    .catch((e) => {
      console.log(e);
      reject("Error while reencrypting beneficiary access");
    });
  });
};

export const revokeAccess = (beneficiary_id) => {
  return new Promise((resolve, reject) => {
    if (!beneficiary_id) reject("No beneficiary_id was provided");
    fetch(base_url + "user/beneficiary/revoke", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `beneficiary_id=${beneficiary_id}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) resolve();
        else throw new Error(res.status);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getBeneficiaryTerms = () => {
  return fetch(base_url + "beneficiary/terms", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const acceptBeneficiaryTerms = () => {
  return new Promise(async (resolve, reject) => {
    submitCaptcha()
      .then((token) => {
        return fetch(base_url + "beneficiary/terms/accept", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          body: `token=${token}`,
          credentials: "include",
        });
      })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject();
      });
  });
};
